import { render, staticRenderFns } from "./md-to-popreply.vue?vue&type=template&id=4dc3de84&scoped=true"
import script from "./md-to-popreply.vue?vue&type=script&lang=js"
export * from "./md-to-popreply.vue?vue&type=script&lang=js"
import style0 from "./md-to-popreply.vue?vue&type=style&index=0&id=4dc3de84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3de84",
  null
  
)

export default component.exports